<template>
  <div class="container">
    <div class="center-head">
      <el-page-header @back="goBack" content="个人中心">
      </el-page-header>
    </div>
    <div class="center-content"><span class="content-title">修改密码</span> <span class="content-pwd"> ******</span>
      <el-button @click="toUpdate"> 修改密码 </el-button>
    </div>

    <el-dialog title='修改密码' :visible.sync="showDialog" custom-class="dialog-form custom-dialog-form">

      <el-form :rules="rules" :model="pwdForm" ref="ruleForm" label-width="auto" label-position="right">
        <password-strength  ref="pwdStrangthRef" v-show="showPwdStrength&&pwdForm.newpwd.length>0" :password="pwdForm.newpwd"></password-strength>
        <el-form-item label="旧密码：" prop="oldpwd">
          <el-input type="password" v-model="pwdForm.oldpwd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newpwd">

          <el-input type="password" v-model="pwdForm.newpwd" @blur="blurNewPwd" @focus="focusNewPwd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码：" prop="checknewpwd">
          <el-input type="password" v-model="pwdForm.checknewpwd" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="updatepwd">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import PasswordStrength from './PasswordStrength.vue';
import JSEncrypt from 'jsencrypt';//引入模块
export default {
  name: "pwdupdate",
  components: {
    PasswordStrength
  },
  wath: {

  },

  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    var validateSamePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.pwdForm.newpwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
        var validateSameOldPwd = (rule, value, callback) => {
      if (value == this.pwdForm.oldpwd) {
        callback(new Error('新密码不能与旧密码一致，请重新输入'));
      } else {
        callback();
      }
    };
   var validateStrength=(rule, value, callback) => {
    let level=  this.$refs['pwdStrangthRef'].checkpassword(value)
      if (level<3 ) {
          callback(new Error('密码强度要求必须包含大小写字母、数字、特殊符号至少三种以上且长度8位以上'));
      } else {
         callback();
     }  };
    return {
      showDialog: false,
      pwdForm: {
        oldpwd: '',
        newpwd: '',
        checknewpwd: ''
      },
      showPwdStrength: false,
      rules: {
        oldpwd: [
          { validator: validatePass, trigger: 'blur' }

        ],
        checknewpwd: [
          { validator: validateSamePass, trigger: 'blur' }

        ],
        newpwd: [
          { validator: validatePass, trigger: 'blur' },
           { validator: validateSameOldPwd, trigger: 'blur' },
          
           { validator: validateStrength, trigger: 'blur' },


        ],

      }
    };
  },
  methods: {
    goBack() {
     this.$emit('back');
    },
    toUpdate() {
      this.showDialog = true;
    },
    blurNewPwd() {
      this.showPwdStrength = false
    },
    focusNewPwd() {
      this.showPwdStrength = true
    },
    updatepwd() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {

          const jse = new JSEncrypt();
          this.$api.post('/resapi/system/getPublicKey').then(res => {
            if (!res.success) {
              this.$message.error(res.info);
            }
            let pubKey = res.data
            jse.setPublicKey(pubKey)
            let oldPwd = jse.encrypt(this.pwdForm.oldpwd);
            let newpwd = jse.encrypt(this.pwdForm.newpwd);
            let checknewpwd = jse.encrypt(this.pwdForm.checknewpwd);
            let params = {
              oldPassword: oldPwd,
              newPassword: newpwd,
              confirmPassword: checknewpwd
            }
            this.$api.post('/resapi/tw/user/changePassword', params).then(res => {
              if (!res.success) {
                this.$message.error(res.info);
                return;
              }
              this.showDialog = false;
              this.$message.success("密码修改成功");
            });


          })
        }
      })

    }

  }
}
</script>

<style lang="scss" >
.container {
  position: relative;
  height: 100%;

  .center-head {
    padding: 25px 20px 25px 32px;
  }
  .center-content {
    position: absolute;
    width: 559px;
    height: 36px;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    .content-title {
      margin-right: 50px;
      line-height: 36px;
    }
    .content-pwd {
      margin-right: 300px;
      line-height: 36px;
    }
  }
  .dialog-form {
    width: 700px;
  }
  .custom-dialog-form .el-dialog__body {
    padding-left: 56px;
    margin-right: 12px;
    max-height: 370px;
  }
  .el-form {
    position: relative;
    .password-container {
      position: absolute;
      top: 100px;
      left: 100px;
      z-index: 999;
    }
  }
}
</style>